import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { UseAuthContext } from "../../store/contexts/auth.context";
import Container from "../../UI/Container";
import CategoryColumn from "../Home/CategoryColumn";
import ProfileInfo from "./ProfileInfo";

function Profile() {
  const { data, posts, getPosts } = UseAuthContext();
  useEffect(() => {
    getPosts();
  }, []);

  const navigate = useNavigate();
  return (
    <Wrapper>
      <Container>
        <h1 className="main-title flex between">
          <div className="flex start">
            Published by Author
            <div className="tag post-count">
              <h1>{posts?.length || 0}</h1>
            </div>
          </div>
          <NavLink to={"edit"} className="tag edit flex align-center">
            <h2>EDIT</h2>
          </NavLink>
        </h1>
        <div className="devider"></div>
        <ProfileInfo />
        <div className="devider"></div>
        <CategoryColumn
          data={posts}
          title="Posts"
          add={
            <input
              style={{ width: "fit-content", marginBottom: "0px" }}
              type={"button"}
              value="Add post"
              className="form-input"
              onClick={() =>
                data.is_verified ? navigate("/add-post") : navigate("verify")
              }
            />
          }
        />
        <div className="devider"></div>
      </Container>
    </Wrapper>
  );
}

export default Profile;
const Wrapper = styled.div`
  @media (max-width: 767px) {
    .post-count {
      padding: 0;
      background-color: #0000;
      font-size: 12px;
    }
    .main-title {
      padding-left: 20px;
    }
    .tag.edit h2 {
      font-size: 12px !important;
    }
  }
`;
